<template>
  <van-notice-bar :scrollable="false" left-icon="volume-o">
    <template #left-icon>
      <img v-show="!showHeadImg" class="notice" src="@/assets/common/NoticeListBar.png" alt="">
    </template>
    <van-swipe
      :autoplay="3000"
      :class="['notice-swipe',]"
      :show-indicators="false"
      vertical
    >
      <van-swipe-item v-for="(item,i) in fictitiousLists" :key="i">
        <img v-show="showHeadImg" class="notice-headbc" :src="item.imgUrl || require('@/assets/common/avator.png')" alt="">
        {{ item.scrollInfo }}
      </van-swipe-item>
    </van-swipe>
  </van-notice-bar>
</template>
<script>
import { NoticeBar, Swipe, SwipeItem } from 'vant'
import { fastConsultBuyUsers } from '@/api'

export default {
  name: 'NoticeListBar',
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    'van-notice-bar': NoticeBar,
  },
  props: {
    showHeadImg: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      fictitiousLists: []
    }
  },
  async created(){
    await this.getConsultList()
  },
  methods: {
    // 滚动信息
    async getConsultList(){
      try {
        let res = await fastConsultBuyUsers()
        this.fictitiousLists = res.data || [
          { scrollInfo: '用户YD** 刚刚提交了咨询' },
          { scrollInfo: '用户65** 刚刚提交了咨询' },
          { scrollInfo: '用户19** 刚刚提交了咨询' },
          { scrollInfo: '用户we** 刚刚提交了咨询' }
        ]
      } catch (error) {
        console.log(error)
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.notice-swipe {
	height: 25px;
	line-height: 27px;
  .notice-headbc{
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #FFFFFF;
    margin-top: 2px;
    margin-right: 5px;
  }
}
.van-swipe-item{
  display: flex;
  align-items: center;
}
.van-notice-bar{
	height: 24px;
  background: #EDF5FF;
	overflow: hidden;
	box-sizing: border-box;
	font-size: 14px;
	color: #177EFF;
	line-height: 16px;
}
.notice{
  width: 16px;
  height: 16px;
  padding-right: 5px;
}
</style>
